import { Component, OnInit } from '@angular/core';
import { IconSetting } from 'src/app/shared/utilities/icon-setting';

@Component({
  selector: 'fgb-account-nav',
  templateUrl: './account-nav.component.html',
  styleUrls: ['./account-nav.component.scss'],
})
export class AccountNavComponent implements OnInit {
  googleIcons = IconSetting.googleIcon;
  constructor() {}

  ngOnInit() {}
}
